import React from 'react';
import { useTranslation } from 'react-i18next';
import { SEARCH_MODAL } from '~/components/ModalController';
import useToggleRuntimeModal from '~/hooks/runtime/useToggleRuntimeModal';
import { Details, Icon, Root, SubTitle, Title } from '../../styles';
import { useTrackNavTile } from '../../hooks/useTrackNavTile';
import { DRAWER_TYPE_SEARCH, NAV_TILE_CLICKED } from '~/core/analytics/events';
import { analyticsTrackEvent } from '~/core/analytics';

const Search = () => {
  const [_, toggle] = useToggleRuntimeModal(SEARCH_MODAL);
  const { t } = useTranslation(['account']);
  useTrackNavTile('search');

  const onClick = () => {
    toggle();
    analyticsTrackEvent(NAV_TILE_CLICKED, {
      action: DRAWER_TYPE_SEARCH,
    });
  };

  return (
    <Root onClick={onClick}>
      <Icon alt="Covid vaccine" src="/images/account/tiles/search.svg" />
      <Details>
        <Title>{t('account:navTiles.search.title')} </Title>
        <SubTitle>{t('account:navTiles.search.subtitle')}</SubTitle>
      </Details>
    </Root>
  );
};

export default Search;
